import 'react-image-lightbox/style.css';

import React, { Component } from "react";
import { callBackendAPI,upperCaseOfName, handleFormInputs,customConfirmBox,reFormatSuccess, setOrGetCookiesValue, generateSource, cancelToken} from '../../helpers/common';
import { STATUS_SUCCESS , PAGING_LENGTH_MENU, RADIO_YES, RADIO_NO,EXPORT_PDF,EXPORT_CSV,SUBCONTRACTOR_PROFILE_STATUS_DROPDOWN,ACTIVE,INACTIVE,PROFILE_INACTIVE, AGREEMENT_TYPE_DROPDOWN, ADMIN, DISPATCHER, PROJECT_MANAGER}  from '../../config/global_constants';
import { translate } from './../../helpers/intl_helpers';
import { NavLink as Link} from "react-router-dom";
import EllipsisPagination from './../Pagination';
import { Table } from 'react-bootstrap';
import Lightbox from 'react-image-lightbox';
import Select from 'react-select';
import Auth from './../../helpers/Auth';

import AddForm from './AddSubContractorForm';
import RequestForm from './AddSubContractorRequestForm';
import SubcontractorDetailModal from './SubcontractorDetailModal';

import closeIcon 	from '../../assets/images/close_icon.svg';
import dataTable 	from '../../assets/images/data-table.svg';
import dataAsc 		from '../../assets/images/data-asc.svg';
import dataDesc 	from '../../assets/images/data-desc.svg';
import mailIcon 	from '../../assets/images/mail-icon.svg';
import callIcon 	from '../../assets/images/call-icon.svg';
import filterIcon 	from '../../assets/images/filter-icon.svg';
import loaderGif 	from '../../assets/images/pagination_loader.gif';
import arrowDown    from '../../assets/images/arrow_down_blue.svg';
import pdfIcon    from '../../assets/images/pdf_icon_01.svg';
import csvIcon    from '../../assets/images/csv_icon.svg';

class SubcontractorList extends Component {
	source;

	constructor(props) {
        super(props);

		/** Get search stats from cookies  */
		let tmpSearchStats = {status: { value: ACTIVE, label: "Active" }};
		let tmpVal =  setOrGetCookiesValue('searchStatsSubContractorList');
		if(tmpVal && tmpVal.constructor === Object && Object.keys(tmpVal).length) tmpSearchStats = tmpVal;

        this.state = {
			isLoading:	true,
			fields   : {},
			searchStats: tmpSearchStats,
			showModel: false,
            userList : [],
            editId: null,
			isAddEmployeeFormVisible: false,
			fileUrl : "",
			noImgUrl: "",
			currentPage: 1,
			totalRecords: 0,
			totalPages	: 0,
			rowsPerPage	: PAGING_LENGTH_MENU[0],
			sortStats	:	{},
			showDetailModal: false,
			profileDetails    : "",
			showRequestModel : false,
			setDocsStatusMap: {}
        };

		this.toggleModal 			  = this.toggleModal.bind(this);
		this.requestModal 			  = this.requestModal.bind(this);
		this.getTableList    		  =	this.getTableList.bind(this);
		this.handleChangePage    	  =	this.handleChangePage.bind(this);
		this.resetSearchStats    	  =	this.resetSearchStats.bind(this);
		this.handlePageLengthChange	  =	this.handlePageLengthChange.bind(this);
		this.handleDeleteEmployee 	  =	this.handleDeleteEmployee.bind(this);
		this.exportTableContent		  =	this.exportTableContent.bind(this);
    }

	/** This function invoked immediately after a component is mounted.
	 * Its use to call initial function.
	 */
	componentDidMount() {
		this.getTableList();
    }

	componentWillUnmount(){
		cancelToken(this.source); // cancel the request
	}

	/** Manage add / update modal box event */
	toggleModal(close , editId) {
		window.closeModal('subcontractorDetailModal');
		this.setState({
			showModel: close,
			editId   : editId
		});
	}

	requestModal(close,editId) {
		window.closeModal('subcontractorDetailModal');
		this.setState({
			showRequestModel: close,
			editId   : editId
		});
	}

	/**
	* For update search state fields values
	*
	* @param fieldName	as current field name
	* @param fieldVal  	as current field value
	*
	* @return null
	*/
	handleChange = (fieldName) => (fieldVal) => {
		this.setState({
			searchStats: {
				...this.state.searchStats,
				[fieldName]: fieldVal
			}
		});
	};

	/**
	* For manage page records limit stats
	*
	* @param lengthOpt as selected limit option params
	*
	* @return null
	*/
	handlePageLengthChange = (lengthOpt) => {
		if(lengthOpt && lengthOpt.value && !isNaN(lengthOpt.value)){
			this.setState({
				rowsPerPage : lengthOpt.value,
				currentPage	: 1,
			},()=>{
				this.getTableList();
			});
		}
	};

	/**
	* For update current page stats
	*
	* @param newPage as selected page number
	*
	* @return null
	*/
	handleChangePage = (newPage = 1,e) => {
		if(e) e.preventDefault();
		this.setState({currentPage: newPage},()=>{
			this.getTableList();
		});
	};

	/**
	* For reset search stats
	*
	* @param null
	*
	* @return null
	*/
	resetSearchStats = () => {
		this.setState({
			searchStats	: {},
			currentPage	: 1,
		},()=>{
			this.getTableList();
		});
	};

	/**
	* For update state fields values
	*
	* @param e  	as current field object
	* @param field  as current field name
	*
	* @return null
	*/
	handleFormInputs(e, field){
		let response	=	handleFormInputs(e, field, this.state.searchStats);
		this.setState({response});
	}// end handleFormInputs()

	/**
	* For export subcontractor listing
	*/
	exportTableContent = (fileType) => {
		this.source = generateSource();

		const {searchStats } = this.state;

		/** Set loading stats */
		window.showLoader();

		/** Set api params */
		let apiReq = {model: 'employee', method: 'employeeExports', file_type: fileType,is_subcontractor : true,allRecords:true};
		if(searchStats && Object.keys(searchStats).length){
			apiReq.company_name		=	searchStats.company_name 	? searchStats.company_name.value 	:"";
			apiReq.email 			=	searchStats.email 			? searchStats.email.value 			:"";
			apiReq.mobile_number 	=	searchStats.mobile_number 	? searchStats.mobile_number.value 	:"";
			apiReq.is_flagger 		=	searchStats.is_flagger 		? searchStats.is_flagger.value 		:"";
			apiReq.status	 		=	searchStats.status 			? searchStats.status.value 			:INACTIVE;
			apiReq.state			=	searchStats.state 			? searchStats.state.value 			:"";
			apiReq.agreement_type	=	searchStats.agreement_type 	? searchStats.agreement_type.value 	:"";
		}

		/** get data table data list */
		callBackendAPI([apiReq],this.source).then(response=>{
			if(response.success && response.data[0].status === STATUS_SUCCESS){
				if(response.data[0].file_url){
					const link 		=	document.createElement('a');
					link.href 		=	response.data[0].file_url;
					link.rel 		=	'noopener noreferrer'; // Security for '_blank' links
					document.body.appendChild(link); // Required for Firefox
					link.click();
					document.body.removeChild(link);
				}

				/** Set loading stats */
				window.hideLoader();
			}
		}).catch(err => console.log(err));
	};// end exportTableContent()

	/**
	 * Manage sort event
	 */
	manageSortingEvent = (event, field, dir) => {
		event.preventDefault();

		this.setState({
			sortStats	: {key: field, dir: dir},
			currentPage	: 1,
		},()=>{
			this.getTableList();
		});
	};

	/**
	* For fetch subcontractor listing
	*/
	getTableList = () => {
		this.source = generateSource();

		const { rowsPerPage, currentPage, searchStats, sortStats } = this.state;

		/** Set loading stats */
		this.setState({isLoading:true},()=>{
			/** Set api params */
			let skip 	=	(currentPage-1)*rowsPerPage;
			let apiReq 	=	{ model: 'employee', method: 'list',is_subcontractor : true, limit: rowsPerPage, start: skip};
			apiReq = {...apiReq, ...{sort_by: sortStats.key ? sortStats.key : "full_name", sort_direction: sortStats.dir ? sortStats.dir : "asc"} };
			if(searchStats && Object.keys(searchStats).length){
				Object.keys(searchStats).forEach(key=>{
					if(searchStats[key]){
						apiReq = {...apiReq, ...{[key]: searchStats[key].value ? searchStats[key].value :""} }
					}
				});
			}

			/** Set search stats in cookies  */
			setOrGetCookiesValue('searchStatsSubContractorList', true, searchStats);

			/** get data table data list */
			callBackendAPI([apiReq],this.source).then(response=>{
				if(response.success && response.data[0].status === STATUS_SUCCESS){
					this.setState({
						userList 	:	response.data[0].result,
						totalRecords: 	response.data[0].recordsTotal,
						totalPages	: 	Math.ceil(response.data[0].recordsTotal/rowsPerPage),
						isLoading	: 	false,
						fileUrl		:	response.data[0].file_url,
						noImgUrl	:	response.data[0].no_img_url
					});
					this.getSubDocStatus();
				}
			}).catch(err => console.log(err));
		});
	};// end getTableList()

    /** Function to handle image lightbox */
    handleImageClick = (imageUrl) => {
        this.setState({
            lightBoxShow: true,
            selectedImage: imageUrl
        });
    }

	/** Function to get sub doc status */
	getSubDocStatus = () => {
		this.source = generateSource();

		callBackendAPI([{ model: "contracts", method: "getSubcontractorDocsStatusForList"}],this.source).then((response) => {
			if (response.success) {
				this.setState({setDocsStatusMap: response?.data?.[0]?.result})
			}
		}).catch(err => console.log(err));
	}

	/** Function to handle delete button click */
	handleDeleteEmployee = (employeeId) => {
		const confirmation = customConfirmBox(translate('subcontractor.you_want_to_delete_subcontractor'));
		confirmation.then((confirmed) => {
			if (confirmed) {
				this.source = generateSource();

				this.closeModal();
				callBackendAPI([{ model: 'employee', method: 'deleteOne', employee_id: employeeId ,is_subcontractor : true }],this.source).then((response) => {
					if (response.success) {
						this.handleChangePage();
						reFormatSuccess(response.data[0].message);
					}
				}).catch(err => console.log(err));
			}
		});
	}

	openDetailModal = (userDetails) => {
		this.setState({ showDetailModal: true, profileDetails: userDetails },()=>{
			window.openModal('subcontractorDetailModal');
		});
	};

	// Close the modal
	closeModal = () => {
		window.document.body.classList.remove("modal-open");
		// window.document.body.classList.remove("overflow-hidden");

		this.setState({ showDetailModal: false, profileDetails: null, showModel: false },()=>{
			window.closeModal('subcontractorDetailModal');
		});
	};

	render() {
        const {userList , fileUrl , noImgUrl ,showModel, searchStats, currentPage, lightBoxShow, selectedImage, rowsPerPage, totalPages, isLoading , editId, sortStats, showDetailModal, profileDetails, showRequestModel} = this.state;

		return <>
			<div className="dashboard-content">
				<div className="dashboard-heading d-flex justify-content-between align-items-center section-head">
				<div className="left-heading d-flex justify-content-between align-items-center">
					<h1>{translate("subcontractor.subcontractor_list")}</h1>
				</div>
					<div className="right-button">
						<Link to="#" className="btn btn-fill btn-filter" data-bs-toggle="collapse" data-bs-target="#subContractorcollapseOne" aria-expanded="true" aria-controls="subContractorcollapseOne">
							<img src={filterIcon} alt="Img" width={29} height={26} />
						</Link>
						{([ADMIN,PROJECT_MANAGER].indexOf(Auth.getPermission()) !== -1) &&
							<Link to="#" className="btn btn-fill"  onClick={() => this.requestModal(true)}>{translate("subcontractor.new_request")}</Link>
						}
					</div>
				</div>
				<div className="filter-box">
					<div className="accordion" id="accordionExample">
						<div className="accordion-item">
							<div id="subContractorcollapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
								<div className="accordion-body">
									<div className="filter-box-header d-flex justify-content-between mb-3">
										<h3 className="mb-0">{translate("employee.filter")}</h3>
										<Link to="#" className="btn-filter-close" data-bs-toggle="collapse" data-bs-target="#subContractorcollapseOne" aria-expanded="true" aria-controls="subContractorcollapseOne">
											<img src={closeIcon} alt="Img" width={20} height={20} />
										</Link>
									</div>
									<form className="adduser-form" onSubmit={(e)=>{ this.handleChangePage(1,e)}}>
										<div className="row">
											<div className="col-lg-4">
												<div className="form-group mb-3">
													<label htmlFor="company_name" className="form-label mb-1">{translate("subcontractor.company_name")}</label>
													<input type="text" className="form-control input-with-label" id="company_name" placeholder={translate("subcontractor.company_name")} value={searchStats["company_name"] ? searchStats["company_name"]["value"] : ""} onChange={(event) => this.handleFormInputs(event, "company_name")}/>
												</div>
											</div>

											<div className="col-lg-4">
												<div className=''>
													<div className="custom-form-group form-group">
													<label className="form-label mb-1">{translate("employee.status")}</label>
													<Select
														className="custom-react-select mx-1"
														options={SUBCONTRACTOR_PROFILE_STATUS_DROPDOWN}
														value={searchStats.status ? searchStats.status : null}
														closeMenuOnSelect={true}
														onChange={this.handleChange("status")}
														placeholder={<label htmlFor="is_flagger">{translate("employee.status")}</label>}
													/>
													</div>
												</div>
											</div>

											<div className="col-lg-3 align-self-center">
												<div className="advanced-btn reports_advanced_filter">
                                                    <button className='d-flex align-items-center w-100 btn' type="button" data-bs-toggle="collapse" data-bs-target="#advanced-filter" aria-expanded="false" aria-controls="advanced-filter">
                                                    Advanced Filter <img src={arrowDown} alt="img" />
                                                    </button>
                                                </div>
											</div>
											<div className="col-lg-12 collapse mt-3" id="advanced-filter">
												<div className="row">
													<div className="col-lg-4">
														<div className="form-group mb-3">
															<label htmlFor="email" className="form-label mb-1">{translate("subcontractor.email")}</label>
															<input type="text" className="form-control input-with-label" id="email" placeholder={translate("employee.email")} value={searchStats["email"] ? searchStats["email"]["value"] : ""} onChange={(event) => this.handleFormInputs(event, "email")}/>
														</div>
													</div>
													<div className="col-lg-4">
														<div className="form-group mb-3">
															<label htmlFor="email" className="form-label mb-1">{translate("subcontractor.mobile_number")}</label>
															<input type="mobile_number" className="form-control input-with-label" id="mobile_number" placeholder={translate("subcontractor.mobile_number")} value={searchStats["mobile_number"] ? searchStats["mobile_number"]["value"] : ""} onChange={(event) => this.handleFormInputs(event, "mobile_number")}/>
														</div>
													</div>
													<div className="col-lg-4">
														<div className="form-group mb-3">
															<label htmlFor="state" className="form-label mb-1" >{translate("subcontractor.state")}</label>
															<input type="text" className="form-control input-with-label" id="state" placeholder={translate("employee.state")} value={searchStats["state"] ? searchStats["state"]["value"] : ""} onChange={(event) => this.handleFormInputs(event, "state")}/>
														</div>
													</div>
													<div className="col-lg-4">
														<div className=''>
															<div className="custom-form-group form-group">
															<label className="form-label mb-1">{translate("subcontractor.flagging_company")}</label>
																<Select
																	className="custom-react-select"
																	options={[
																		{label: translate("system.yes"), value: String(RADIO_YES)},
																		{label: translate("system.no"), value: String(RADIO_NO)}
																	]}
																	value={searchStats.is_flagger ? searchStats.is_flagger : null}
																	closeMenuOnSelect={true}
																	isClearable={true}
																	onChange={this.handleChange("is_flagger")}
																	placeholder={<label htmlFor="is_flagger">{translate("employee.is_flagger")}</label>}
																/>
															</div>
														</div>
													</div>
													<div className="col-lg-4">
														<div className=''>
															<div className="custom-form-group form-group">
															<label htmlFor="state" className="form-label mb-1" >{translate("subcontractor.agreement_type")}</label>
															<Select
																className="custom-react-select mx-1"
																options={AGREEMENT_TYPE_DROPDOWN.map(key=>{return {value: key.value, label: key.label }})}
																value={searchStats.agreement_type ? searchStats.agreement_type : null}
																closeMenuOnSelect={true}
																onChange={this.handleChange("agreement_type")}
																placeholder={<label htmlFor="agreement_type">{translate("subcontractor.agreement_type")}</label>}
															/>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="col-md-12 d-flex">
												<button className="btn btn-fill me-3 width-height-initial" type="submit" onClick={(e)=>{ this.handleChangePage(1,e) }} >{translate("system.submit")}</button>
												<button className="btn btn-outline" onClick={() => this.resetSearchStats()}>{translate("system.reset")}</button>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="row mb-3">
					<div className="col-7">
						<div className="form-group d-flex align-items-center mb-3 table-count">
							{translate("system.show")}
							<Select
								className="custom-react-select mx-1"
								options={PAGING_LENGTH_MENU.map(key=>{return {value: key, label: key }})}
								value={{label:rowsPerPage, value:rowsPerPage}}
								closeMenuOnSelect={true}
								onChange={this.handlePageLengthChange}
							/>
							{translate("system.entries")}
						</div>
					</div>
					{([ADMIN, DISPATCHER].indexOf(Auth.getPermission()) !== -1) &&
						<div className="col-5 text-end ">
							<div className="form-group export-btns d-block">
								<div className="dropdown">
									<button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
										Export
									</button>
									<ul className="dropdown-menu">
										<li>
											{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
											<a href="#" className="dropdown-item" onClick={(e)=>{e.preventDefault(); this.exportTableContent(EXPORT_PDF)}}>
												<img src={pdfIcon} alt="img" width={22} height={22} />
											{translate("reports.export_as_pdf")}
											</a>
										</li>
										<li>
											{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
											<a href="#" className="dropdown-item" onClick={(e)=>{e.preventDefault(); this.exportTableContent(EXPORT_CSV)}}>
												<img src={csvIcon} alt="img" width={22} height={22} />
											{translate("reports.export_as_csv")}
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					}
				</div>

                <div className="users-list">
					<div className="table-responsive theme-table">
						<Table bordered responsive>
							<thead>
								<tr>
									<th width='10%'>
										{translate('subcontractor.image')}
									</th>
									<th width='15%' className="cursor-pointer" onClick={(event)=>{this.manageSortingEvent(event, "first_name", (sortStats && sortStats.key === "first_name" && sortStats.dir === "asc" ? "desc" :"asc")) }}>
										{translate('subcontractor.name')}

										<span className="m-l-10">
											{(!sortStats || !sortStats.key) || (sortStats && sortStats.key !== "first_name") ?
												<img src={dataTable} alt="sorting-opt" />
											:(sortStats && sortStats.key === "first_name" ? (
												sortStats.dir === 'asc' ?
													<img src={dataAsc} alt="sorting-asc"  />
												:
												<img src={dataDesc} alt="sorting-desc" />
											):null)}
										</span>
									</th>
									<th width='15%'>
										{translate('subcontractor.contact_name')}
									</th>
									<th width='15%'>
										{translate('subcontractor.email')}
									</th>
									<th width='10%'>
										{translate('subcontractor.mobile')}
									</th>
									<th width='10%'>
										{translate('subcontractor.status')}
									</th>
									<th width='15%'>
										{translate('subcontractor.expired_reason')}
									</th>
								</tr>
							</thead>
							<tbody>
								{isLoading ?
									<tr>
										<td colSpan="7" className='text-center'>
											<img src={loaderGif} alt="loading-icon" />
										</td>
									</tr>
								: userList && userList.length ?
									userList.map((row, rowIndex) => (
										<tr key={"subcontractor-list" + rowIndex}>
											<td>
												<div className="user-info">
													<span className={`sort-name ${(!row.image) ? 'greenbg' : ''}`}>
														{row && row.image ? (
															<img src={`${fileUrl}${row.image}`} alt="employee" onError={(event) => event.target.src = noImgUrl} onClick={() => this.handleImageClick(`${fileUrl}${row.image}`)} />
														) : (
															upperCaseOfName(row.first_name ? row.first_name : "", row.last_name ? row.last_name : "")
														)}
													</span>
												</div>
											</td>
											<td>
												<Link
													to="#"
													className="user-type-link view-modal-details"
													onClick={(e) => {
														e.preventDefault();
														this.openDetailModal(row);
													}}
												>
													{row.company_name ? row.company_name : ""}
												</Link>
											</td>
											<td>
												<span className="user-type">
													{row.contact_name ? row.contact_name : ""}
												</span>
											</td>
											<td>
												<span className="user-type">
													<img src={mailIcon} alt="img" width={19} height={21} />
													{row.email ? (
														<a href={`mailto:${row.email}`} className="email-link text-lowercase">
															{row.email}
														</a>
													) : ""}
												</span>
											</td>
											<td>
												<span className="user-type">
													<img src={callIcon} alt="img" width={19} height={21} />
													{row.mobile ? (
														<a href={`tel:${row.mobile}`}>{row.mobile}</a>
													) : ""}
												</span>
											</td>
											<td>
												<span className={row?.active === ACTIVE ? "text-success" : "text-danger"}>
													{
														row?.active === ACTIVE ? translate('employee.active') :
														row?.active === PROFILE_INACTIVE ? translate('employee.inactive') :
														translate('employee.suspended')
													}
												</span>
											</td>
											<td>
												<span>
													{(() => {
														if(row?.active === ACTIVE || row?.active === PROFILE_INACTIVE) return "-";

														const subId = row?.subcontract_request_id?.toString();
														if (!subId) return "-";

														const docStatus = this.state.setDocsStatusMap?.[subId];
														if (!docStatus) return "-";

														const { missing = [], expired = [] } = docStatus;
														if (!missing.length && !expired.length) return "-";

														return (
															<>
																{missing.length > 0 && (
																	<div>
																		<strong>Missing:</strong> {missing.join(", ")}
																	</div>
																)}
																{expired.length > 0 && (
																	<div>
																		<strong>Expired:</strong> {expired.join(", ")}
																	</div>
																)}
															</>
														);
													})()}
												</span>
											</td>
										</tr>
									))
								:
									<tr>
										<td colSpan="7" className='text-center'>
											<div className="text-center">{translate("employee.no_data_available_in_table")}</div>
										</td>
									</tr>
								}
							</tbody>
						</Table>
					</div>
					<EllipsisPagination currentPage={currentPage} totalPages={totalPages} onChange={this.handleChangePage} />
				</div>
                {
					lightBoxShow &&
					<Lightbox
						mainSrc={selectedImage}
						onCloseRequest={() => this.setState({ lightBoxShow: false })}
					/>
				}
			</div>
		  	{showModel ?
				<AddForm editId={editId} fetchEmployeeList={this.getTableList} handleDeleteEmployee={this.handleDeleteEmployee}  toggleModal={this.toggleModal}/>
			: null}
		  	{showRequestModel ?
				<RequestForm requestModal={this.requestModal} />
			: null}
			 {/*Detail Modal component */}
			 {showDetailModal ?
				<SubcontractorDetailModal profileDetails={profileDetails} closeModal={this.closeModal} toggleModal={this.toggleModal} fileUrl={fileUrl} noImgUrl={noImgUrl} />
			: null}
		</>
	}
}
export default SubcontractorList;